const Footer = () => {
  return (
    <p className="bg-gray-300 py-2 text-center text-lg">&copy; 2022 Maou</p>
  );
};

export default Footer;
